import { render, staticRenderFns } from "./GateSizeAndMotorization.vue?vue&type=template&id=e6471682&scoped=true"
import script from "./GateSizeAndMotorization.vue?vue&type=script&lang=ts"
export * from "./GateSizeAndMotorization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6471682",
  null
  
)

export default component.exports